import CustomDialog from '../Dialog/Dialog';

interface PayoutInfoPopupProps {
    open: boolean;
    handleClose: () => void;
    state: string;
    storeKey: string;
}

export default function PayoutInfoPopup({ open, handleClose, state, storeKey }: PayoutInfoPopupProps) {
    return (
        <CustomDialog
            open={open}
            handleClose={handleClose}
            title={`Enable Automatic Payout`}
            handleSubmit={() => { }}
            width="486px"
            isLoading={false}
            fullWidth={true}
        >
            <p className="payout-info-popup-text">We are not connected to your <span className="payout-info-popup-text-bold">{state}</span> Lottery Account.</p>
            <p className="payout-info-popup-text">
                You can enable automatic syncing by inviting LottoReco to your account.</p>
            <p className="payout-info-popup-text">
                Please invite <span className="payout-info-popup-text-bold">{storeKey}</span><span className="payout-info-popup-text-link">{"@lottoreco.com"}</span> to your State Lottery account.</p>
            <p className="payout-info-popup-text">
                Once we receive the invitation email, our system will automatically begin syncing Payout and Scratcher Activation data from your account.
            </p>
        </CustomDialog>
    )
}